import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-404" />, document.getElementById('root'));